import {
  mapGetters, mapMutations, mapState 
} from 'vuex'

import ApiService from '@/services/ApiService'

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.profile.user,
    }),
    ...mapGetters({
      appLoader: 'app/appLoader',
      currentUserId: 'profile/currentUserId',
      customerFileCompletion: 'profile/customerFileCompletion',
      currentUserName: 'profile/currentUserName',
      currentConfig: 'common/currentConfig',
      enumsOptions: 'common/enumsOptions',
      currentUser: 'profile/currentUser',
      currentPeople: 'profile/currentPeople',
      currentUserRole: 'profile/currentUserRole',
      peopleDetails: 'profile/peopleDetails',
      drawerOpen: 'profile/drawerOpen',
      formErrors: 'profile/formErrors',
      selectedProfileIndex: 'profile/selectedProfileIndex',
      selectedProfile: 'profile/selectedProfile',
      selectedProfileIsLoaded: 'profile/selectedProfileIsLoaded',
      isLoaded: 'profile/isLoaded',
      requiredAttributes: 'common/requiredAttributes',
      optionalAttributes: 'common/optionalAttributes',
      requiredDocuments: 'common/requiredDocuments',
      optionalDocuments: 'common/optionalDocuments',
      currentFields: 'admin/currentFields',
    }),
    drawerOpen: {
      get() {
        return this.$store.state.profile.drawerOpen
      },
      set(value) {
        return value
      },
    },
    isCRM() {
      return this.currentUserRole === 'ADMIN'
    },
  },
  methods: {
    ...mapMutations({
      toggleAppLoader: 'app/toggleAppLoader',
    }),
    async refreshSelectedProfile(all) {
      this.toggleAppLoader(true)
      const result = await ApiService.getPerson(this.selectedProfileIndex)
      const person = Object.assign({}, result)
      this.toggleAppLoader(false)
      // add checks to errors handler
      const checks = person.data.person_controls[0].checks
      const checkErrors = {}
      Object.keys(checks).forEach((item) => {
        if (checks[item] !== null && !checks[item]) {
          checkErrors[item] = ['non-valid-data',]
        }
      })
      this.$store.commit('profile/setFormErrors', checkErrors)
      this.$store.commit('profile/setCustomerFileCompletion', person.data.meta.customer_file_completion_rate)
      if (all) {
        this.$store.commit('profile/updateSelectedPerson', person.data)
        this.$store.commit('profile/updatePerson', person.data)
      } else {
        this.$store.commit('profile/updateSelectedPersonMetaDocs', person.data)
        this.$store.commit('profile/updatePersonMetaDocs', person.data)
      }
    },
    async refreshMainProfile() {
      this.toggleAppLoader(true)
      const result = await ApiService.getPerson(this.currentUser.id)
      const person = Object.assign({}, result)
      this.$store.commit('profile/updatePerson', person.data)
      this.toggleAppLoader(false)
    },
    navigateTo(route) {
      this.$router.push({ name: route, })
    },
  },
}
